export function normalizePhone(value?: string) {
  return (value || '').replace(/\D+/g, '')
}

export function formatPhone(value?: string) {
  const digits = normalizePhone(value)
  if (digits.length !== 10) return value || '—'
  return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)} ${digits.slice(6)}`
}
